import {
    clearAuxResourceName,
    clearAuxResourceUrl,
    clearExperienceMarker, clearGeoData, clearMapBounds,
    setGeoData, setMapBounds, setMapFilter,
    setNavOption, setPrevNavOption, setTitle
} from "./commit_helpers";
import { requestNavClose, requestNavOpen } from "./nav_helpers";

// Use this function when a navOption is selected - could be via a user action (click), url loading or other event triggering.
export function selectNavOption(sm, navOption) {

    if (navOption.mapBounds && sm.state['renderMapBounds'] === true) {
        setMapBounds(sm, navOption.mapBounds);
    } else {
        clearMapBounds(sm);
    }

    if (navOption.hasGeoData()) {
        navOption.getGeoData().then((geoData)=>{
            if (typeof geoData == 'object') setGeoData(sm, geoData);
        });
    } else {
        clearGeoData(sm);
    }

    // The map filter is the new nav option's map filter or whatever the current one is.
    // When the nav option is a subpage it won't have a map filter so we continue to use the current one in state or the default one for the online app.
    const mapFilter = navOption.mapFilter || sm.state['mapFilter'] || navOption.onlineApp.defaultMapFilter();
    if (mapFilter) {
        setTitle(sm, mapFilter.getMapTitle());
        setMapFilter(sm, mapFilter);
        setPrevNavOption(sm, null); // clear the prev nav option so that closing the Aux doesn't change the navOption
    }

    // If we're not `modal` then we should never close the Nav.
    // If we're `modal` then the focus might want to be on the map, so we'd close the nav.
    // The Nav owns navOpen (plan 2026-07-15), so request the change rather than setting it here;
    // the Nav persists it and emits the signal the online_app reflects (navOpenReflected).
    // Skip on the INITIAL deep-link resolution — the Nav's restored persisted navOpen must stand
    // (plan 2026-07-20 follow-up); this fires only in modal, so it's the mobile reload path.
    // `hasPendingInitialRoute()` is false for user clicks and in-session routes, so those are
    // unchanged (and native never reaches here — the OnlineAppRouter is web-only).
    if (sm.state['modal'] && !sm.getStateableObject().hasPendingInitialRoute()) {
        let shouldCloseNav = navOption.shouldCloseNav();
        shouldCloseNav ? requestNavClose() : requestNavOpen();
    }

    clearExperienceMarker(sm);
    clearAuxResourceUrl(sm);
    clearAuxResourceName(sm);

    setNavOption(sm, navOption);
}
